/** Creativity levels */
const CREATIVITY_LEVELS = {
    Repetitive: 'Repetitive',
    Deterministic: 'Deterministic',
    Normal: 'Normal',
    Creative: 'Creative',
    Imaginative: 'Imaginative',
};
/** Creativity levels in numbers */
const CREATIVITY_LEVELS_IN_NUMBERS = {
    Repetitive: 0.1,
    Deterministic: 0.3,
    Normal: 0.5,
    Creative: 0.7,
    Imaginative: 0.9,
};
export { CREATIVITY_LEVELS, CREATIVITY_LEVELS_IN_NUMBERS, };
